(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * 
	 * 
	 * @description
	 * 
	 */
	angular.module('paxMessage').service('PaxMessageService',
			PaxMessageService);

	function PaxMessageService(PaxMessageFactory,
			RemoteService, CommonMasterData) {
		
		var self = this;
		var model = {
			paxMsgSearchCriteria: PaxMessageFactory.getPaxMessageSearchRequest(),
			paxMsgList :[],
			reSumitData :PaxMessageFactory.getResubmitRequest(),
			flightLegId :null,
			triggerId :null
		};

		self.setPaxMessageSearchCriteria = function(searchParams) {
			var paxMsgSearch = PaxMessageFactory.getPaxMessageSearchRequest();
			paxMsgSearch.fromDate = searchParams.fromDate;
			paxMsgSearch.toDate = searchParams.toDate;
			paxMsgSearch.flightNumber = searchParams.flightNumber;
			if(!!searchParams.country && !!searchParams.country.icaoCode){
				paxMsgSearch.countryCode = searchParams.country.icaoCode;
			}
			if(!!searchParams.crewStatus && !!searchParams.crewStatus.responseStatusCode){
				paxMsgSearch.crewStatus = searchParams.crewStatus.responseStatusCode;
			}
			if(!!searchParams.responseStatus && !!searchParams.responseStatus.responseStatusCode){
				paxMsgSearch.responseCode = searchParams.responseStatus.responseStatusCode;
			}
			model.paxMsgSearchCriteria = paxMsgSearch;
		};
		
		
		self.getPaxMessages = function(successFn, errorFn){
			RemoteService.getPaxMessages(model.paxMsgSearchCriteria).then(
	                function (response) {
	                    if(response.success){
	                        successFn(response.paxMsgList);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );
		};
		
		self.override = function(params,successFn, errorFn){
			var override = PaxMessageFactory.getOverrideData();
			override.paxMsgJourneyCrewId = params.paxMsgJourneyCrewId;
			override.paxMsgSchdId = params.paxMsgSchdId;
			override.overideCode = params.overideCode;
			
			RemoteService.paxMessageOverride(override).then(
	                function (response) {
	                    if(response.success){
	                        successFn(response);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );
			
		};
		
		self.setResubmitData = function(data){
			var resubmit = PaxMessageFactory.getResubmitRequest();
			resubmit.paxMsgSchdId = data.paxMsgSchdId;
			angular.forEach(data.paxMsgCrew, function(crew) {
				if(crew.isSelected){
					resubmit.paxMsgJourneyCrewIds.push(crew.paxMsgJourneyCrewId)
				}
			});
			model.reSumitData = resubmit;
		}
		
		self.reSubmit = function(successFn, errorFn){
			RemoteService.getPaxMsgReSubmit(model.reSumitData).then(
	                function (response) {
	                    if(response.success){
	                        successFn(response.paxMsgList);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );
		};
		
		self.setManualySendAppData = function(data){
			var sendData = PaxMessageFactory.getResubmitRequest();
			sendData.flightLegId = data.flightLegId;
			sendData.triggerId = data.triggerId;
			model.reSumitData = sendData;
			
		};
		
		self.manualySendApp = function(successFn, errorFn){
			RemoteService.sendPaxMsgManualy(model.reSumitData).then(
	                function (response) {
	                    if(response.success){
	                        successFn();
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );
		};
		
		self.resubmitCancel = function(params,successFn, errorFn){
			
			var cnxResubmit = PaxMessageFactory.getOverrideData();
			cnxResubmit.paxMsgJourneyCrewId = params.paxMsgJourneyCrewId;
			cnxResubmit.paxMsgSchdId = params.paxMsgSchdId;
			
			RemoteService.resubmitCancellation(cnxResubmit).then(
	                function (response) {
	                    if(response.success){
	                        successFn(response);
	                    }
	                },
	                function (error) {
	                    errorFn(error.msg[0]);
	                }
	        );
		}
		
	}
})();